const CSRF_COOKIE_NAME = "XSRF-TOKEN";
const CSRF_HEADER_NAME = "X-XSRF-TOKEN";

function getCookie(name: string): string | undefined {
    return document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${name}=`))
        ?.slice(name.length + 1);
}

export function addCsrfHeader(headers: Headers): void {
    const csrfToken = getCookie(CSRF_COOKIE_NAME);

    if (csrfToken) {
        headers.set(CSRF_HEADER_NAME, decodeURIComponent(csrfToken));
    }
}
